import { createSlice } from "@reduxjs/toolkit";
import ArticleReducer from "@/components/ArticlePage/redux/reducers";
import { articleInitialState } from "@/components/ArticlePage/redux/initialState";

const articleSlice = createSlice({
  name: "article",
  initialState: articleInitialState,
  reducers: ArticleReducer,
});

export const { setLoading, setError, setArticleData, setDevice, setArticleSlug } = articleSlice.actions;

export default articleSlice.reducer;
